import { createVanIconComponent } from "./van"

const ChartTrendingOutlined = createVanIconComponent("chart-trending-o")
export default ChartTrendingOutlined
